"use strict";
/**
 * @module Services.Timeseries
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a TIME_SERIES_TIMESTAMP_APPEND request.
 */
var TimeSeriesTimestampAppendRequest = /** @class */ (function () {
    /**
     * Create a new TimeSeriesAppendRequest instance
     *
     * @param path  the path of the timeseries topic
     * @param dataType  the data type to append
     * @param value  the value to append
     */
    function TimeSeriesTimestampAppendRequest(path, dataType, value, timestamp) {
        this.path = path;
        this.dataType = dataType;
        this.value = value;
        this.timestamp = timestamp;
    }
    return TimeSeriesTimestampAppendRequest;
}());
exports.TimeSeriesTimestampAppendRequest = TimeSeriesTimestampAppendRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/timeseries/time-series-timestamp-append-request.js
// module id = 2001
// module chunks = 1